module.exports = __webpack_public_path__ + "img/interac.1aa4c68.svg";